import "./Footer.css";

function Footer() {
  return (
    <div className="footer footer-bottom">
      <div className="container">
        <div className="row row-cols-xs-spaced flex flex-items-xs-middle">
          <div className="col col-sm-7 col-xs-12">
            <div className="copyright text-xs-center text-sm-left">
              Copyright © 2025{" "}
              <a
                href="http://rieles.co"
                target="_blank"
                title="Rieles.co - Official Website"
                rel="noreferrer"
              >
                <strong className="strong-400">Rieles</strong>
              </a>{" "}
              - All rights reserved
            </div>
          </div>
          <div className="col col-sm-5 col-xs-12">
            <div className="text-xs-center text-sm-right">
              <ul className="social-media social-media--style-1-v4">
                <li>
                  <a
                    href="https://www.facebook.com/Arrendamientoslacasona/"
                    className="facebook"
                    target="_blank/"
                    data-toggle="tooltip"
                    data-original-title="Facebook"
                    rel="noreferrer"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/arrendamientoslacasona/"
                    className="instagram"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Instagram"
                    rel="noreferrer"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=573182962222&amp;text=Estoy%20buscando%20una%20propiedad"
                    className="whatsapp"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Whatsapp"
                    rel="noreferrer"
                  >
                    <i className="fa fa-whatsapp"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
